import React, { memo } from 'react';
import classnames from 'classnames';

import { Advice, Text, useTheme } from '@Sage/hoi-poi-ui';

const RatesSectionBlock = memo(({ title, advice, subtitle, extraText, className, children }) => {
    const theme = useTheme();

    return (
        <div className={classnames('rates-crud-section', className)}>
            {title ? (
                <Text as="div" className="rates-crud-section__title" type="subtitle1" bold>
                    {title}
                </Text>
            ) : null}
            {advice || subtitle || extraText ? (
                <div className="rates-crud-section__intro">
                    {advice ? (
                        <Advice showCollapse={false} showIcon type="info">
                            {advice}
                        </Advice>
                    ) : null}
                    {subtitle ? (
                        <Text
                            as="div"
                            className="rates-crud-section__subtitle"
                            color={theme.colors.utility.textSecondary}
                            type="body"
                        >
                            {subtitle}
                        </Text>
                    ) : null}
                    {extraText ? (
                        <Text
                            as="div"
                            className="rates-crud-section__extra"
                            color={theme.colors.utility.textSecondary}
                            type="caption"
                        >
                            {extraText}
                        </Text>
                    ) : null}
                </div>
            ) : null}
            {children}
        </div>
    );
});

RatesSectionBlock.displayName = 'RatesSectionBlock';

export default RatesSectionBlock;
